import {MUTATION_KEYS} from '@/queryClient.ts'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {ErrorResponseData} from '@/types'
import {httpPasswordRecovery} from './auth.http'

type UsePasswordRecoveryOptions = {
    onSuccess?: () => void
    onError?: (error: AxiosError<ErrorResponseData>) => void
}

export const usePasswordRecovery = (options?: UsePasswordRecoveryOptions) =>
    useMutation({
        mutationKey: [MUTATION_KEYS.PASSWORD_RECOVERY],
        mutationFn: httpPasswordRecovery,
        onError: (error: AxiosError<ErrorResponseData>) => options?.onError?.(error),
        onSuccess: () => options?.onSuccess?.()
    })
